export default {
  action: {
    margin: '10px 0',
    textDecoration: 'none'
  }
};
